import { IProject } from './../models/project';
import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { Observable, map } from 'rxjs';
import { IResponse } from '../models/response';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: "root",
})
export class ProjectService {

  constructor(private _http: HttpClient, private _authService: AuthService) { }

  getAllOrganizations() {
    return this._http.get(apiconstants.API_ALL_ORGANIZATIONS);
  }
  getProjectType() {
    return this._http.get(apiconstants.API_PROJECT_TYPE);
  }
  getProjectContinent() {
    return this._http.get(apiconstants.API_PROJECT_CONTINENT);
  }
  getAllProjects(params?): Observable<IProject> {
    return this._http.get(apiconstants.API_PROJECTS, { params }).pipe(
      map((response: IResponse) => {
        return <IProject>response;
      })
    );
  }
  getAllProjectList(params?): Observable<IProject> {
    return this._http.get(apiconstants.API_USER_PROJECTS, { params }).pipe(
      map((response: IResponse) => {
        return <IProject>response;
      })
    );
  }
  getJsnProjectList(params?): Observable<IProject> {
    return this._http.get(apiconstants.API_PROJECT_FROM_JSN, { params }).pipe(
      map((response: IResponse) => {
        return <IProject>response;
      })
    );
  }

  getProjectDetails(projectId: string): Observable<any> {
    return this._http.get(apiconstants.API_PROJECT + `/${projectId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
  getUserProjectApproval(projectId: string): Observable<any> {
    return this._http.get(apiconstants.API_USER_PROJECT_APPROVAL + `/project/${projectId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
  getUserProjectEnableApproval(projectId: string): Observable<any> {
    let queryParams = {
      projectid: projectId,
      contactid: this._authService.user.contact_id
    }
    return this._http.get(apiconstants.API_USER_PROJECT_APPROVAL, { params: queryParams }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  addProjectApproval(body) {
    return this._http.post(apiconstants.API_USER_PROJECT_APPROVAL, body).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }
  addProject(projetdetails) {
    return this._http.post(apiconstants.API_PROJECTS, projetdetails).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  updateProject(id, projetdetails) {
    return this._http.put(apiconstants.API_PROJECTS + `/${id}`, projetdetails).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  addClient(clientDetails, projectid) {
    return this._http.post(apiconstants.API_POST_CLIENT + `/${projectid}`, clientDetails).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  updateClient(clientDetails, projectid) {
    return this._http.put(apiconstants.API_PUT_CLIENT + `/${projectid}`, clientDetails).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

}
